import React, { PropTypes, PureComponent } from 'react';
import TextInput from '../inputs/TextInput';
import { Button, Table } from 'react-fast-ui';
import _ from 'underscore';

const ROUND_NAMES = [ 'Final', 'Semifinal', 'Quarterfinal' ];
const getRoundName = (round, height) => {
  return round >= ROUND_NAMES.length ? `Round ${height - round}` : ROUND_NAMES[ round ];
};

export default class LabelBracketForm extends PureComponent {
  static propTypes = {
    value: PropTypes.shape({
      bracketLabel: PropTypes.string,
      height: PropTypes.number.isRequired,
      roundInfo: PropTypes.arrayOf(
        PropTypes.shape({
          prefix: PropTypes.string.isRequired,
          suffix: PropTypes.string.isRequired
        })
      ),
    }).isRequired,
    onChange: PropTypes.func.isRequired
  };
  static defaultProps = {
    value: null
  };

  changed = more => this.props.onChange({ ...this.props.value, ...more });
  labelChanged = ({ target: { value: bracketLabel } }) => this.changed({ bracketLabel });

  changeRoundInfo = roundInfo => this.changed({ roundInfo });

  fillDefaults = prop => {
    const { value: { height } } = this.props;

    this.changeRoundInfo(
      _.map(
        _.range(0, height),
        round => ({ prefix: '', suffix: '', [ prop ]: getRoundName(round, height) })
      )
    );
  };

  defaultPrefixes = () => this.fillDefaults('prefix');
  defaultSuffixes = () => this.fillDefaults('suffix');

  changeRound = (round, attr) => {
    const { value: { roundInfo, height } } = this.props;

    const newRoundInfo = _.isArray(roundInfo) && roundInfo.length === height ?
      [ ...roundInfo ] :
      _.map(_.range(0, height), round => ({
        prefix: '',
        height: ''
      }));

    newRoundInfo[ round ] = { ...newRoundInfo[ round ], ...attr };

    this.changeRoundInfo(newRoundInfo);
  };

  render() {
    const { value: { bracketLabel, roundInfo, height }, onChange, ...rest } = this.props;

    return (
      <div {...rest}>
        <div>
          <label>Bracket Name</label>
          <TextInput placeholder="Bracket Label" value={bracketLabel || ''} onChange={this.labelChanged}/>
        </div>
        <hr/>
        <div>
          <Table>
            <Table.thead>
              <Table.th>Round</Table.th>
              <Table.th>Prefix</Table.th>
              <Table.th>Suffix</Table.th>
              <Table.th>Result</Table.th>
            </Table.thead>
            <Table.tbody>
              {
                _.map(
                  _.range(0, height),
                  round => {
                    const info = roundInfo && roundInfo.length > round ? roundInfo[ round ] : null;
                    const name = getRoundName(round, height);
                    const prefix = info ? info.prefix || '' : '';
                    const suffix = info ? info.suffix || '' : '';

                    return (
                      <Table.tr key={round}>
                        <Table.td>{name}</Table.td>
                        <Table.td>
                          <TextInput placeholder={name} value={prefix}
                            onChange={({ target: { value: prefix } }) => this.changeRound(round, { prefix })}/>
                        </Table.td>
                        <Table.td>
                          <TextInput placeholder={name} value={suffix}
                            onChange={({ target: { value: suffix } }) => this.changeRound(round, { suffix })}/>
                        </Table.td>
                        <Table.td>
                          {prefix} {bracketLabel} {suffix}
                        </Table.td>
                      </Table.tr>
                    );
                  }
                )
              }
              <Table.tr key="default">
                <Table.td/>
                <Table.td className="text-center">
                  <Button text="Default" onClick={this.defaultPrefixes}/>
                </Table.td>
                <Table.td className="text-center">
                  <Button text="Default" onClick={this.defaultSuffixes}/>
                </Table.td>
                <Table.td/>
              </Table.tr>
            </Table.tbody>
          </Table>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/forms/LabelBracketForm.jsx